define('app/views/region_selector_view',['app/setup'], function(takhfifan) {

  takhfifan.RegionSelectorView = Backbone.View.extend({

    events: {
      'click li' : 'updateRegion'
    },

    initialize: function() {
      var _this = this;
      this.update();
    },

    render: function() {
    },

    setRegion: function() {
      this.model.set('region', this.$el.val());
    },

    setViewRegion: function(region) {
      $option = this.$('option[value="' + region + '"]').first();
      this.$('span.value').first().html($option.html());
      $option.prop('selected', true);
    },

    updateRegion: function(event) {
      var region = $(event.target).data('region-id');
      this.setViewRegion(region);

      if (!_.isNumber(region)) {
        this.model.set('region', null);
      } else {
        this.model.set('region', region);
      }
    },

    update: function() {
      this.render();
    }

  });
});

